import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import { Trigger } from 'models/automation/Triggers';
import TriggerAddEditModal from './TriggerAddEditModal';
import { TRIGGER_ADD_EDIT_MODAL_ID } from './TriggerAddEditModal.constants';

const useTriggerAddEditModal = () => {
  const { openModal } = useAppModal();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateBack = () => {
    navigate('..', { replace: true, relative: 'path' });
  };

  const openAddTriggerModal = () => {
    openModal({
      customContent: <TriggerAddEditModal closeModal={navigateBack} />,
      id: TRIGGER_ADD_EDIT_MODAL_ID,
      title: t('pageAutomations.triggers.modal.addTitle'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  const openEditTriggerModal = ({ triggerUid }: { triggerUid: string }) => {
    openModal({
      customContent: (
        <TriggerAddEditModal
          triggerUid={triggerUid}
          closeModal={navigateBack}
        />
      ),
      id: TRIGGER_ADD_EDIT_MODAL_ID,
      title: t('pageAutomations.triggers.modal.editTitle'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  const openDuplicateTriggerModal = (originalTrigger: Trigger) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { uid, ...triggerWithoutUid } = originalTrigger;

    openModal({
      customContent: (
        <TriggerAddEditModal
          originalTrigger={{
            ...triggerWithoutUid,
            name: `${originalTrigger.name} copy`,
          }}
          closeModal={navigateBack}
        />
      ),
      id: TRIGGER_ADD_EDIT_MODAL_ID,
      title: t('pageAutomations.triggers.modal.addTitle'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  return {
    openAddTriggerModal,
    openDuplicateTriggerModal,
    openEditTriggerModal,
  };
};

export default useTriggerAddEditModal;
